export enum AUDIENCE_TARGET {
  BILLING_CLIENT = 'BILLING_CLIENT',
  SHIPPING_CLIENT = 'SHIPPING_CLIENT',
  ADMIN = 'ADMIN',
  CUSTOM = 'CUSTOM',
}
